module.exports = __webpack_public_path__ + "img/2026-03-24b_3.466e9beb.jpg";